import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { LoginPage } from "../../../pages/LoginPage";
import { AppLayout } from "../../../pages/AppLayout";
import { OptionsPage } from "../../../pages/OptionsPage";
import { PlatformsPage } from "../../../pages/PlatformsPage";
import { DashboardPage } from "../../../pages/DashboardPage";
import { FmvPage } from "../../../pages/FmvPage";
import { ProvidersPage } from "../../../pages/ProvidersPage";
import { CalculatorPage } from "../../../pages/CalculatorPage";
import { TfsSrpYearRatesPage } from "../../../pages/TfsSrpYearRatesPage";

export const RoutesComponent = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route
          path="/platforms"
          element={<AppLayout route={{ component: PlatformsPage }} />}
        />
        <Route
          path="/providers"
          element={<AppLayout route={{ 
            component: ProvidersPage,
            title: "Providers Management",
            breadCrumbs: [
              { path: "/dashboard", breadcrumbName: "Dashboard" },
              { path: "/providers", breadcrumbName: "Providers" },
            ]
          }} />}
        />
        <Route
          path="/fmv"
          element={<AppLayout route={{ 
            component: FmvPage,
            title: "Fair Market Value (FMV)",
            breadCrumbs: [
              { path: "/dashboard", breadcrumbName: "Dashboard" },
              { path: "/fmv", breadcrumbName: "FMV" },
            ]
          }} />}
        />
        <Route
          path="/options"
          element={<AppLayout route={{ component: OptionsPage }} />}
        />
        <Route
          path="/dashboard"
          element={<AppLayout route={{
            component: DashboardPage,
            title: "Dashboard",
            breadCrumbs: [
              { path: "/dashboard", breadcrumbName: "Dashboard" },
              { path: "/dashboard", breadcrumbName: "Overview" },
            ]
          }} />}
        />
        <Route
          path="/calculator"
          element={<AppLayout route={{
            component: CalculatorPage,
            title: "Installment Calculator",
            breadCrumbs: [
              { path: "/dashboard", breadcrumbName: "Dashboard" },
              { path: "/calculator", breadcrumbName: "Calculator" },
            ]
          }} />}
        />
        <Route
          path="/tfs-srp-year-rates"
          element={<AppLayout route={{
            component: TfsSrpYearRatesPage,
            title: "TFS SRP Year Rates",
            breadCrumbs: [
              { path: "/dashboard", breadcrumbName: "Dashboard" },
              { path: "/tfs-srp-year-rates", breadcrumbName: "TFS SRP Year Rates" },
            ]
          }} />}
        />
        <Route path="*" element={<Navigate to="/dashboard" replace={true} />} />
      </Routes>
    </BrowserRouter>
  );
};
